<template>
  <select
    :name="optionName"
    @change="inputEventHandler"
    v-model="selected"
    class="form-control"
    required
  >
    <option value="">Select location</option>
    <option class="optionHover" value="ZOOM ONLINE">ZOOM ONLINE</option>
    <option class="optionHover" value="Kimberley Street, London">
      Kimberley Street, London
    </option>
    <option class="optionHover" value="Dublin, Ireland">Dublin, Ireland</option>
    <option class="optionHover" value="Studio Doom Yoga, London">
      Studio Doom Yoga, London
    </option>
  </select>
  <!-- <select :name="optionName" @change="inputEventHandler" v-model="selected" class="form-control">
   
    <option
      v-for="location in locations"
      :key="location"
      :value="location"
      :selected="location == selected"
      >{{ location }}</option
    >
  </select> -->
  <!-- <option v-show="isFirstRow(index) && onlyOneRow(hours)" value>{{
      defaultText
    }}</option>
    <option v-show="isFirstRow(index)" value="24hrs">{{
      localization.t24hours
    }}</option>
    <option
      v-for="time in locations"
      :key="time"
      :value="time"
      :selected="time == selected"
      >{{ time | formatTime(hourFormat24) }}</option
    > -->
  <!-- <input v-model="selected" :name="optionName" class="form-control"  @change="inputEventHandler" /> -->
</template>

<script>
import { helperMixin } from "../../mixins/helperMixin";
import { formFieldMixin } from "../../mixins/formFieldMixin";
export default {
  name: "LocationsSelect",
  mixins: [helperMixin, formFieldMixin],
};
</script>



// WEBPACK FOOTER //
// src/components/vue-business-hours/LocationsSelectDoomYoga.vue